<!--Mobile card-->

<div class="modal-content rounded-0 bg-primary" *ngIf="barcode$ | async as barcode">
  <div class="container pb-3" [ngClass]="{ 'mt-3': isHomePage }">
    <div class="modal-body p-0 flex-column d-flex gap-2">
      <ng-container *ngIf="!isWalletPage">
        <div class="modal-header w-100 d-flex align-items-center justify-content-between">
          <div class="header-left">
            <div
              class="card-name text-white text-uppercase font-size-14 font-page-heading"
              *ngIf="member$ | async as memberDetails"
            >
              {{ memberDetails.FirstName }} {{ memberDetails.Surname }}
            </div>
            <div class="account-num-header text-white" *ngIf="card$ | async as memberCard">
              <span class="font-size-12">{{ 'barcode.memberid' | translate }} </span>
              <span class="font-size-12">{{ memberCard.ExternalRefNumber }}</span>
            </div>
          </div>
          <div class="header-right">
            <div class="wallet-text" routerLink="/rewards/wallet">
              <span class="icons text-white material-symbols-outlined"> qr_code_scanner </span>
              <a class="text-white font-size-14">{{ 'member.card.wallet' | translate }}</a>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="isWalletPage">
        <div class="qr-container w-100">
          <div class="qr p-2">
            <qrcode
              [qrdata]="barcode.Barcode"
              [width]="120"
              [height]="120"
              [errorCorrectionLevel]="'M'"
              [elementType]="'svg'"
            ></qrcode>
          </div>

          <span class="font-size-12 text-white text-center">
            {{ 'qr.scan.text' | translate }}
          </span>
          <ng-container *ngIf="member$ | async as member">
            <fgb-mobile-pass [memberId]="member.MemberId"></fgb-mobile-pass>
          </ng-container>
        </div>
      </ng-container>

      <div class="d-flex justify-content-between align-items-center mb-2 mt-2 w-100">
        <div class="d-flex mb-1 points-container w-100 justify-content-between">
          <div class="points-item" *ngIf="pointsBalance$">
            <span class="icons material-icons" aria-hidden="true">loyalty</span>
            <div class="points-balance">
              <div class="text-number font-size-18 font-page-heading">
                {{ pointsBalance$ | async }}
              </div>
              <div class="text-unit font-size-12">{{ 'member.card.points.label' | translate }}</div>
            </div>
          </div>
          <div class="points-item" *ngIf="ecashBalance$">
            <span class="icons material-symbols-outlined"> money_bag </span>
            <div class="e-cash-section">
              <div class="text-number font-size-18 font-page-heading">{{ ecashBalance$ | async | FortressCurrencyPipe }}</div>
              <div class="text-unit font-size-12">{{ 'member.card.ecash.label' | translate }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="add-card mb-2">
        <fgb-add-card-payment />
      </div>

      <!-- mobile navigation -->
      <ng-container *ngIf="isHomePage">
        <div class="mobile-navigation d-flex flex-row align-items-center justify-cotent-center gap-4 pb-2 mb-2">
          <div class="navigation" routerLink="/rewards">
            <span class="icons material-symbols-outlined"> redeem </span>
            <a class="text-white font-size-14">{{ 'member.card.rewards' | translate }}</a>
          </div>

          <div class="navigation" routerLink="/challenges">
            <span class="icons material-symbols-outlined"> emoji_events </span>
            <a class="text-white font-size-14">{{ 'member.card.challenges' | translate }}</a>
          </div>

          <div class="navigation" routerLink="/ecash">
            <span class="icons material-symbols-outlined"> credit_card </span>
            <a class="text-white font-size-14">{{ 'member.card.ecash' | translate }}</a>
          </div>

          <div class="navigation" routerLink="/earn">
            <span class="icons material-symbols-outlined"> money </span>
            <a class="text-white font-size-14">{{ 'member.card.earn' | translate }}</a>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
